<template>
    <QuickEventCreation></QuickEventCreation>
</template>
<script>
import QuickEventCreation from '@/components/screener/QuickEvents/QuickEventCreation'
export default {
  name: "QuickEvents",
  data() {
    return {
      dialog: true,
    };
  },
  components: {
    QuickEventCreation
  },
  methods: {
    reset() {
      this.dialog = false;
    },
  },
};
</script>
